import { BasicSentryService } from "@app/init/sentry/BasicSentryService";
import { isPrerenderCrawler } from "../environmentsBasic";

export async function initSentry() {
	const sentryService = new BasicSentryService();
	window.sentryBasicToFullMigrationData = {
		getCapturedErrors: () => sentryService.capturedErrors,
		clean: () => {
			sentryService.cleanHandlers();
			delete window.sentryBasicToFullMigrationData;
		}
	};

	if (isPrerenderCrawler) {
		return;
	}

	sentryService.initialize();
}
